import { Card, Spin } from "antd";
import { DataCard } from "../../../shared/ui/DataCard";
import { OriginPill, StatusPill } from "./StatusBadges";
import { FLOW_TYPE_LABELS, formatCarrier } from "../constants";

function getFlowSummary(reserva) {
  if (!reserva) return "";
  const parts = [];
  if (reserva.flowType) parts.push(FLOW_TYPE_LABELS[reserva.flowType] || reserva.flowType);
  const carrier = formatCarrier(reserva);
  if (carrier) parts.push(carrier);
  return parts.join(" · ");
}

export function PedidoMobileList({ pedidos, loading, onSelect }) {
  return (
    <Card className="te-card">
      <div style={{ marginBottom: 16 }}>
        <h3 style={{ margin: 0, color: "var(--te-primary)" }}>Lista de pedidos</h3>
        <p className="te-kicker">Visualização simplificada dos pedidos do sistema.</p>
      </div>
      {loading ? (
        <div className="te-empty">
          <Spin />
        </div>
      ) : pedidos.length === 0 ? (
        <div className="te-empty">Nenhum pedido encontrado.</div>
      ) : (
        <div className="te-stack">
          {pedidos.map((pedido) => {
            const summary = getFlowSummary(pedido.reserva);
            return (
              <DataCard
                key={pedido.id}
                title={`Pedido #${pedido.orderNumber || "-"}`}
                badge={<StatusPill status={pedido.status} />}
                rows={[
                  { label: "Cliente", value: pedido.user?.fullName || "-" },
                  { label: "Origem", value: <OriginPill origin={pedido.origin} /> },
                  { label: "Locker", value: pedido.colleto?.name || "-" },
                  ...(summary ? [{ label: "Resumo", value: summary }] : []),
                ]}
                onClick={() => onSelect(pedido.id)}
              />
            );
          })}
        </div>
      )}
    </Card>
  );
}
